import { getCallLogsById } from "Listfunction";
import { Button, Tooltip } from "react-bootstrap";
import moment from "moment";
import React, { Component } from "react";
import { OverlayTrigger, Table } from "react-bootstrap";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class ConsultationLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      callLogsData: [],
      consultId: "",
      isLoading: false,
    };
  }

  openCallLoigModal(ConsultationId) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ isLoading: true });

    getCallLogsById(obj, ConsultationId)
      .then((res) => {
        this.setState({ callLogsData: res.data.payload });
        this.setState({ isLoading: false });
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
        this.setState({ isLoading: false });
      });
  }
  copyTheDeviceInfoDetails(deviceInfo) {
    const textFile = JSON.stringify(deviceInfo);
    navigator.clipboard.writeText(textFile);
    this.handleSuccess("tr", "Object Coppied.");
  }

  render() {
    return (
      <div style={{ margin: 10 }}>
        <div style={{ display: "flex", gap: "8px", margin: 10 }}>
          <input
            className="form-control"
            type="number"
            name="consultId"
            onChange={(e) =>
              this.setState({
                consultId: e.target.value,
              })
            }
            style={{
              Width: "25%",
            }}
            value={this.state.consultId}
          />
          <Button onClick={() => this.openCallLoigModal(this.state.consultId)}>
            Search
          </Button>
          <Button
            onClick={() => this.setState({ callLogsData: [], consultId: "" })}
          >
            Clear
          </Button>
        </div>
        <Table>
          <thead>
            <th>Action</th>
            <th>Description</th>
            <th>Application</th>
            <th>DeviceInfo</th>
            <th>Date</th>
            <th>User</th>
            <th>Consultation</th>
          </thead>
          <tbody>
            {this.state.isLoading && <div>Loading...............</div>}
            {this.state.callLogsData.length === 0 ? (
              <tr>
                <td colSpan="10">
                  <center>No data found....</center>
                </td>
              </tr>
            ) : (
              this.state.callLogsData &&
              this.state.callLogsData.map((data) => (
                <tr>
                  <td>{data.action === null ? "" : data.action}</td>
                  <td>{data.description === null ? "" : data.description}</td>
                  <td>{data.application === null ? "" : data.application}</td>
                  <td>
                    {data.deviceInfo !== null || undefined || "" ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="deviceInfo">
                            {
                              <>
                                <p>
                                  Device type:{" "}
                                  {data.deviceInfo.deviceType !== null || ""
                                    ? data.deviceInfo.deviceType
                                    : ""}
                                </p>
                                <p>
                                  Room socket connected:{" "}
                                  {data.deviceInfo.isRoomSocketConnected ===
                                  true
                                    ? "yes"
                                    : "No"}
                                </p>
                                <p>
                                  Socket connected:{" "}
                                  {data.deviceInfo.isSocketConnected === true
                                    ? "yes"
                                    : "No"}
                                </p>
                                <p>
                                  Network type:{" "}
                                  {data.deviceInfo.deviceType !== null || ""
                                    ? data.deviceInfo.deviceType
                                    : ""}
                                </p>
                                <p>
                                  OS version:{" "}
                                  {data.deviceInfo.osVersion !== null || ""
                                    ? data.deviceInfo.osVersion
                                    : ""}
                                </p>
                              </>
                            }
                          </Tooltip>
                        }
                      >
                        <Button
                          onClick={() =>
                            this.copyTheDeviceInfoDetails(data.deviceInfo)
                          }
                        >
                          Copy
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>
                    {data.dateAndTime === null
                      ? ""
                      : moment(data.dateAndTime).format("YYYY-MM-DD hh:mm:ss")}
                  </td>
                  <td>
                    {data.user !== null || undefined || "" ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="user">
                            {
                              <>
                                <p>
                                  Name:{" "}
                                  {data.user.name !== null || ""
                                    ? data.user.name
                                    : ""}
                                </p>
                                <p>
                                  Email:{" "}
                                  {data.user.email !== null || ""
                                    ? data.user.email
                                    : ""}
                                </p>
                                <p>
                                  Mobile No:{" "}
                                  {data.user.phoneNumber !== null || ""
                                    ? data.user.phoneNumber
                                    : ""}
                                </p>
                                <p>
                                  Admin user Id:{" "}
                                  {data.user.adminUserId !== null || ""
                                    ? data.user.adminUserId
                                    : ""}
                                </p>
                                <p>
                                  User Type:{" "}
                                  {data.user.userType !== null || ""
                                    ? data.user.userType
                                    : ""}
                                </p>
                              </>
                            }
                          </Tooltip>
                        }
                      >
                        <Button
                          style={{
                            border: "none",
                            margin: "0px",
                            padding: "0px",
                          }}
                          onClick={() =>
                            this.copyTheDeviceInfoDetails(data.user)
                          }
                        >
                          {data.user.name}
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>
                    {data.consultation !== null || undefined || "" ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="consultation">
                            {
                              <>
                                <p>
                                  Consultation Id:{" "}
                                  {data.consultation.consultationId !== null ||
                                  ""
                                    ? data.consultation.consultationId
                                    : ""}
                                </p>
                                <p>
                                  Flash Consultation Id:{" "}
                                  {data.consultation.flashConsultationId !==
                                    null || ""
                                    ? data.consultation.flashConsultationId
                                    : ""}
                                </p>
                                <p>
                                  Call Type:{" "}
                                  {data.consultation.callType !== null || ""
                                    ? data.consultation.callType
                                    : ""}
                                </p>
                                <p>
                                  Doctor Name:{" "}
                                  {data.consultation.doctorName !== null || ""
                                    ? data.consultation.doctorName
                                    : ""}
                                </p>
                                <p>
                                  Patient Name:{" "}
                                  {data.consultation.patientName !== null || ""
                                    ? data.consultation.patientName
                                    : ""}
                                </p>
                              </>
                            }
                          </Tooltip>
                        }
                      >
                        <Button
                          onClick={() =>
                            this.copyTheDeviceInfoDetails(data.consultation)
                          }
                        >
                          Copy
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default ConsultationLogs;
